import { render, staticRenderFns } from "./SalaryEvents.vue?vue&type=template&id=60c817fd&scoped=true"
import script from "./SalaryEvents.vue?vue&type=script&lang=js"
export * from "./SalaryEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c817fd",
  null
  
)

export default component.exports